export const GetTables = () => `
SELECT 
    *
FROM 
    sqlite_schema
WHERE 
    type ='table'
`;

export const GetTableInfo = (tableName: string) => `
PRAGMA table_info(${tableName})
`;
